import React, { useCallback, useEffect, useState } from 'react'

import { Button, Row, SimpleCollapse } from 'components'
import { useAuth, useLoading, useModal, useMovement } from 'hooks'
import moment from 'moment'
import { Entity, IEvidenciaMovMensal } from 'pages/Supplier/MovMensal/types'
import { MovimentacaoMensalServices } from 'services/Supplier/MovMensal'
import { FORMAT, SPACING } from 'utils'
import { convertBase64 } from 'utils/functions'

import {
  AnexarEvidencias,
  DadosEfetivo,
  EfetivoNumero,
  HorasExtras,
  Tipo,
  ValoresContratada
} from './components'
import { boolean } from 'yup'
import { ConsolidationServices } from 'services/NGT/Parameterization'

interface IVisaoTotalParams {
  handleTab: any
  isDataExpirada: boolean
  consolidacaoFechada: boolean // Adicione esta prop
}

const VisaoTotal: React.FC<IVisaoTotalParams> = ({
  handleTab,
  isDataExpirada,
  consolidacaoFechada //Adicione esta prop
}) => {
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { allDatadescripted, user } = useAuth()
  const {
    movState,
    selectedMovement,
    isAnalista,
    isContraparte,
    competenciaSelecionada,
    blockTotalVision,
    setMovState,
    dataAtuacaoInvalida,
    errorsTotalVision,
    isSomenteCompartilhado,
    isSemMobilizacao,
    isComMobilizacao
  } = useMovement()

  /*
   *
   * ANEXAR EVIDENCIAS
   *
   *
   */

  const [listaEvidencias, setListaEvidencias] = useState<
    IEvidenciaMovMensal[] | []
  >([])
  const [listaParaEnviar, setListaParaEnviar] = useState<
    IEvidenciaMovMensal[] | []
  >([])

  const getEvidenciasMov = useCallback(async () => {
    setLoading('loading')
    try {
      const response = await MovimentacaoMensalServices().getEvidenciaMovMensal(
        movState?.movimentacaoId
      )
      if (response.status !== 204 && response.status !== 200)
        throw Error('Error obter evidencias.')

      if (response.status === 204) {
        setListaEvidencias([])
        setLoading('idle')
        return
      }

      setListaEvidencias(response.data)
      setLoading('idle')
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: obterMsgErroGuardaDocumento(
          error,
          'Não foi possivel obter evidências',
          'Não foi possível obter evidências. Serviço de guarda de documento está offline.'
        ),
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
  }, [movState?.movimentacaoId])

  useEffect(() => {
    if (allDatadescripted.Perfil === 'Csn' && movState?.movimentacaoId) {
      getEvidenciasMov()
    }
  }, [getEvidenciasMov])

  let isUploading = false;

  const onPutFile = async (files) => {
    if (isUploading) return; // Impede chamadas duplicadas

    isUploading = true; // Bloqueia novas execuções
    setLoading('loading');
    try {
      const newFiles = [];

      for (let i = 0; i < files.length; i++) {
        const fileBase64 = (await convertBase64(files[i])) as string;

        const newObj: IEvidenciaMovMensal = {
          base64: fileBase64,
          dsDocumento: files[i].name,
          dsExtensaoDoc: files[i].type || 'application/octet-stream',
          usuarioMatricula: files[i].usuarioMatricula || ''
        };

        newFiles.push(newObj);
        setListaParaEnviar((old) => [...old, newObj]);
        setListaEvidencias((old) => [...old, newObj]);
      }

      const updatedList = [...newFiles];
      if (updatedList.length > 0) {
        const latestFile = updatedList[updatedList.length - 1];

        const objEnvio = {
          contratoId: selectedMovement.contratoId,
          descricao:
            latestFile.dsExtensaoDoc !== ''
              ? latestFile.dsExtensaoDoc
              : 'DOCUMENTO ANEXADO',
          documentoPaiId: movState.movimentacaoId,
          file: FORMAT.file(latestFile.base64),
          forncedorId: selectedMovement.fornecedorId,
          nomeArquivo: latestFile.dsDocumento,
          nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
          tipoDocumentoId: 3,
          tipoPendenciaId: 110,
          usuarioId: user.IdUsuario,
        };

        await MovimentacaoMensalServices().anexarEvidenciaMensal(objEnvio);
      }

      setLoading('idle');
    } catch (error: any) {
      setLoading('idle');
      showModal({
        hideButtonCancel: true,
        message:
          error.message || error.mensagem || 'Não foi possível inserir arquivo',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      });
    } finally {
      isUploading = false;
    }
  };
  const handleEnviarEvidencias = async (
    movimentacaoIdFromMovCreation?: number
  ): Promise<any> => {
    if (listaParaEnviar?.length > 0) {
      try {
        setLoading('loading')

        for (let i = 0; i < listaParaEnviar.length; i++) {
          const objEnvio = {
            contratoId: selectedMovement.contratoId,
            descricao:
              listaParaEnviar[i].dsExtensaoDoc != ''
                ? listaParaEnviar[i].dsExtensaoDoc
                : 'DOCUMENTO ANEXADO',
            documentoPaiId:
              movState.movimentacaoId || movimentacaoIdFromMovCreation,
            file: FORMAT.file(listaParaEnviar[i].base64),
            forncedorId: selectedMovement.fornecedorId,
            nomeArquivo: listaParaEnviar[i].dsDocumento,
            nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
            tipoDocumentoId: 3,
            tipoPendenciaId: 110,
            usuarioId: user.IdUsuario
          }

          const response =
            await MovimentacaoMensalServices().anexarEvidenciaMensal(objEnvio)

          if (response.status !== 200) {
            throw Error('Não foi possivel enviar evidencia.')
          }
        }
        setListaParaEnviar([])
        setLoading('idle')
        return new Promise((resolve, reject) => resolve(true))
      } catch (err: any) {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: obterMsgErroGuardaDocumento(
            err,
            'Não foi possivel inserir arquivo'
          ),
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
        return new Promise((resolve, reject) => reject())
      }
    }
  }

  const obterMsgErroGuardaDocumento = (
    err: any,
    defaultValue: string,
    customMsg?: string
  ) => {
    if (!err.message && !err.mensagem) return defaultValue
    if (
      err?.message?.includes('SMARTSHARE_OFF') ||
      err?.mensagem?.includes('SMARTSHARE_OFF')
    ) {
      return (
        customMsg ||
        'Serviço de guarda de documento offline! Tente novamente em instantes.'
      )
    } else {
      return err.message || err.mensagem
    }
  }

  const handleDeleteEvidencias = async (el: IEvidenciaMovMensal) => {
    setLoading('loading')
    if (el.anexoDocumentoId != null && el.anexoDocumentoId != 0) {
      let response
      try {
        response = await MovimentacaoMensalServices().deleteEvidenciaMensal(
          el.anexoDocumentoId
        )

        if (response.status != 200) {
          throw new Error('Erro ao Deletar Evidencia!')
        } else {
          const newArray = listaEvidencias.filter(
            (x: IEvidenciaMovMensal) =>
              x.dsDocumento != el?.dsDocumento || x.base64 != el?.base64
          )
          const newArraySend = listaParaEnviar.filter(
            (x: IEvidenciaMovMensal) =>
              x.dsDocumento != el?.dsDocumento || x.base64 != el?.base64
          )

          setListaEvidencias(newArray)
          setListaParaEnviar(newArraySend)
        }

        showModal({
          hideButtonCancel: true,
          message: 'Sucesso, Documento Deletado com Sucesso',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
        setLoading('idle')
      } catch (err: any) {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: obterMsgErroGuardaDocumento(
            err,
            'Não foi possivel Deletar a Evidencia, Ocorreu um Erro.'
          ),
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      }
    } else {
      const newArray = listaEvidencias.filter(
        (x: IEvidenciaMovMensal) =>
          x.dsDocumento != el?.dsDocumento || x.base64 != el?.base64
      )
      const newArraySend = listaParaEnviar.filter(
        (x: IEvidenciaMovMensal) =>
          x.dsDocumento != el?.dsDocumento || x.base64 != el?.base64
      )

      setListaEvidencias(newArray)
      setListaParaEnviar(newArraySend)
      setLoading('idle')
    }
  }

  /*
   *
   * ANEXAR EVIDENCIAS
   *
   *
   */

  /*
   *
   * SALVAR MOVIMENTACAO
   *
   *
   */

  const handleCreateMovimentacao = () => {
    setLoading('loading')

    const { visaoTotal, compAtual: movEfetivos } = movState
    const haveMobilizacao = (movState.flStatusMobilizacao !== '0') as boolean

    MovimentacaoMensalServices()
      .createMov({
        movEfetivos: haveMobilizacao
          ? movEfetivos.map(
            ({ flDelete, $id, cdContrato, ...efetivo }: Entity) => ({
              ...efetivo,
              ...(efetivo.vlHoraExtras && {
                vlHoraExtras: Number(
                  String(efetivo.vlHoraExtras).replace('R$', '')?.trim()
                )
              }),
              ...(efetivo.vlSalBase && {
                vlSalBase: Number(
                  String(efetivo.vlSalBase).replace('R$', '').trim()
                )
              }),
              cdCategoria: efetivo.cdCategoria?.trim(),
              cdContraparte: FORMAT.unMask(efetivo.cdCpfPassaporte),
              cdNacionalidade: efetivo.cdNacionalidade?.trim(),
              cdStatus: efetivo.cdStatus?.trim().toUpperCase(),
              cdTipoEfetivo: efetivo.cdTipoEfetivo?.trim(),
              fornecedorId: selectedMovement.fornecedorId,
              idMovEfetivo: 0,
              movimentacaoId: movState.movimentacaoId,
              nuAnoMesCompetencia: competenciaSelecionada
            })
          )
          : [],
        movimentacao: {
          cdAnalista: '',
          cdContraparte: '',
          flSalvarVerificar: false,
          idMovimentacao: movState.movimentacaoId,
          ...(isAnalista && {
            cdAnalista: String(user.IdUsuario),
            dtValidAnalista: moment().toISOString(),
            flValidAnalista: true,
            flValidContraparte: movState.flValidContraparte
          }),
          ...(isContraparte && {
            cdContraparte: String(user.IdUsuario),
            dtValidContraparte: moment().toISOString(),
            flValidAnalista: movState.flValidAnalista,
            flValidContraparte: true
          }),
          contratoCompartilhadoId: movState?.contratoCompartilhadoId || visaoTotal?.contratoCompartilhadoId || null,
          contratoId: selectedMovement.contratoId,
          flMovValida: visaoTotal?.flMovValida,
          flStatusMobilizacao: movState.flStatusMobilizacao,
          nuAnoMesCompetencia: competenciaSelecionada,
          peHeVariacao: Number(visaoTotal?.peHeVariacao) || 0,
          peNePercVarAtual: Number(visaoTotal?.peNePercVarAtual) || 0,
          peValVariacao: visaoTotal?.peValVariacao || 0,
          qtAcesso: visaoTotal?.qtAcesso,
          qtAfastado: visaoTotal?.qtAfastado,
          qtAtivo: visaoTotal?.qtAtivo,
          qtAutonomo: visaoTotal?.qtAutonomo,
          qtClt: visaoTotal?.qtClt,
          qtCompartilhado: visaoTotal?.qtCompartilhado,
          qtCooperado: visaoTotal?.qtCooperado,
          qtDemitido: visaoTotal?.qtDemitido,
          qtEstagiario: visaoTotal?.qtEstagiario,
          qtEstrangeiro: visaoTotal?.qtEstrangeiro,
          qtHeNormal: FORMAT.horasCSNToFloat(visaoTotal?.qtHeNormal) || 0,
          qtHeQtd: FORMAT.horasCSNToFloat(visaoTotal?.qtHeQtd) || 0,
          qtMei: visaoTotal?.qtMei,
          qtNeAtual: visaoTotal?.qtNeAtual,
          qtSocio: visaoTotal?.qtSocio,
          qtTotalEfetivo: visaoTotal?.qtTotalEfetivo,
          qtTransferido: visaoTotal?.qtTransferido,
          txHeJustificativa: visaoTotal?.txHeJustificativa,
          txNeJustificativa: visaoTotal?.txNeJustificativa,
          txSalBaseJustificativa: visaoTotal?.txSalBaseJustificativa,
          usuarioId: user.IdUsuario,
          vlFolhaPagto: Number(visaoTotal?.vlFolhaPagto) || 0,
          vlHoraExtras: Number(visaoTotal?.vlHoraExtras) || 0,
          vlNeVariacaoAtual: visaoTotal?.vlNeVariacaoAtual,
          vlSalBase: Number(visaoTotal?.vlSalBase) || 0
        }
      })
      .then(async (response) => {
        if (response.status !== 200 || !response.data.sucesso) {
          throw new Error(
            response.data.mensagem || allDatadescripted.Perfil === 'Csn'
              ? 'Não foi possível validar a movimentação'
              : 'Não foi possível enviar movimentação'
          )
        }

        setMovState((prevState) => ({
          ...prevState,
          movimentacaoId: response.data.valor.mov.idMovimentacao
        }))

        // Salva as evidencias anexadas no momento do lançamento de Mov Mensal
        if ([isAnalista, isContraparte].includes(true)) {

          await handleEnviarEvidencias(response.data.valor.mov.idMovimentacao)
        }

        // handleEnviarValidar({ action: 'updateMov' })
        setLoading('idle')
        showModal({
          handleConfirm: () => handleTab(null, 0),
          hideButtonCancel: true,
          message:
            allDatadescripted.Perfil === 'Csn'
              ? 'Movimentação validada com sucesso'
              : 'Movimentação enviada com sucesso',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
      })
      .catch((error: Error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleEnviarValidar = ({
    action
  }: {
    action: 'createMov' | 'updateMov'
  }) => {
    setLoading('loading')

    const { visaoTotal, compAtual: movEfetivos } = movState
    const haveMobilizacao = (movState.flStatusMobilizacao !== '0') as boolean

    if (visaoTotal.vlHoraExtras == null && visaoTotal.qtHeQtd != null) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Não é permitido salvar uma quantidade de horas extras sem o seu valor devidamente preenchido.',
        txtButtonConfirm: 'OK',
        type: 'error'
      })
      return;
    }

    if (visaoTotal?.vlHoraExtras == null || visaoTotal?.vlHoraExtras == 0) {
      visaoTotal.txHeJustificativa = null;
    }

    const movEfetivosSemDeletado = movEfetivos.filter(x => !x.flDelete)
    const verificaTotalEfetivos: boolean = movEfetivosSemDeletado.length != visaoTotal?.qtAtivo + visaoTotal?.qtAcesso + visaoTotal?.qtDemitido + visaoTotal?.qtTransferido + visaoTotal?.qtAfastado + visaoTotal?.qtCompartilhado ? true : false;

    if ((verificaTotalEfetivos && haveMobilizacao == true)) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'A quantidade de colaboradores não esta fechando com o totalizador, validação negada. Avise os gestores do sistema NGT.',
        txtButtonConfirm: 'OK',
        type: 'error'
      })
      return;
    }

    const actions = {
      createMov: MovimentacaoMensalServices().createMov,
      updateMov: MovimentacaoMensalServices().updateMov
    }

    actions[action]({
      movEfetivos: haveMobilizacao
        ? movEfetivos.filter(({ flDelete }) => !flDelete).map(
          ({ flDelete, $id, cdContrato, ...efetivo }: Entity) => ({
            ...efetivo,
            ...(efetivo.vlHoraExtras && {
              vlHoraExtras: Number(
                String(efetivo.vlHoraExtras).replace('R$', '')?.trim()
              )
            }),
            ...(efetivo.vlSalBase && {
              vlSalBase: Number(
                String(efetivo.vlSalBase).replace('R$', '').trim()
              )
            }),
            cdCategoria: efetivo.cdCategoria?.trim(),
            cdContraparte: FORMAT.unMask(efetivo.cdCpfPassaporte),
            cdNacionalidade: efetivo.cdNacionalidade?.trim(),
            cdStatus: efetivo.cdStatus?.trim().toUpperCase(),
            cdTipoEfetivo: efetivo.cdTipoEfetivo?.trim(),
            fornecedorId: selectedMovement.fornecedorId,
            idMovEfetivo: 0,
            movimentacaoId: movState.movimentacaoId,
            nuAnoMesCompetencia: competenciaSelecionada
          })
        )
        : [],
      movimentacao: {
        cdAnalista: '',
        cdContraparte: '',
        flSalvarVerificar: false,
        idMovimentacao: movState.movimentacaoId,
        ...(isAnalista && {
          cdAnalista: String(user.IdUsuario),
          dtValidAnalista: moment().toISOString(),
          flValidAnalista: true,
          flValidContraparte: movState.flValidContraparte
        }),
        ...(isContraparte && {
          cdContraparte: String(user.IdUsuario),
          dtValidContraparte: moment().toISOString(),
          flValidAnalista: movState.flValidAnalista,
          flValidContraparte: true
        }),
        contratoCompartilhadoId: visaoTotal?.contratoCompartilhadoId || null,
        contratoId: selectedMovement.contratoId,
        flMovValida: visaoTotal?.flMovValida,
        flStatusMobilizacao: movState.flStatusMobilizacao,
        nuAnoMesCompetencia: competenciaSelecionada,
        peHeVariacao: Number(visaoTotal?.peHeVariacao) || 0,
        peNePercVarAtual: Number(visaoTotal?.peNePercVarAtual) || 0,
        peValVariacao: visaoTotal?.peValVariacao || 0,
        qtAcesso: visaoTotal?.qtAcesso,
        qtAfastado: visaoTotal?.qtAfastado,
        qtAtivo: visaoTotal?.qtAtivo,
        qtAutonomo: visaoTotal?.qtAutonomo,
        qtClt: visaoTotal?.qtClt,
        qtCompartilhado: visaoTotal?.qtCompartilhado,
        qtCooperado: visaoTotal?.qtCooperado,
        qtDemitido: visaoTotal?.qtDemitido,
        qtEstagiario: visaoTotal?.qtEstagiario,
        qtEstrangeiro: visaoTotal?.qtEstrangeiro,
        qtHeNormal: FORMAT.horasCSNToFloat(visaoTotal?.qtHeNormal) || 0,
        qtHeQtd: FORMAT.horasCSNToFloat(visaoTotal?.qtHeQtd) || 0,
        qtMei: visaoTotal?.qtMei,
        qtNeAtual: visaoTotal?.qtNeAtual,
        qtSocio: visaoTotal?.qtSocio,
        qtTotalEfetivo: visaoTotal?.qtTotalEfetivo,
        qtTransferido: visaoTotal?.qtTransferido,
        txHeJustificativa: visaoTotal?.txHeJustificativa,
        txNeJustificativa: visaoTotal?.txNeJustificativa,
        txSalBaseJustificativa: visaoTotal?.txSalBaseJustificativa,
        usuarioId: user.IdUsuario,
        vlFolhaPagto: Number(visaoTotal?.vlFolhaPagto) || 0,
        vlHoraExtras: Number(visaoTotal?.vlHoraExtras) || 0,
        vlNeVariacaoAtual: visaoTotal?.vlNeVariacaoAtual,
        vlSalBase: Number(visaoTotal?.vlSalBase) || 0
      }
    })
      .then((response) => {
        if (response.status !== 200 || !response.data.sucesso) {
          throw new Error(
            response.data.mensagem || allDatadescripted.Perfil === 'Csn'
              ? response.data.mensagem ??
              'Não foi possível validar a movimentação'
              : response.data.mensagem ?? 'Não foi possível enviar movimentação'
          )
        }

        setLoading('idle')

        showModal({
          handleConfirm: () => handleTab(null, 0),
          hideButtonCancel: true,
          message:
            allDatadescripted.Perfil === 'Csn'
              ? 'Movimentação validada com sucesso'
              : 'Movimentação enviada com sucesso',
          txtButtonConfirm: 'Fechar',
          type: 'success'
        })
      })
      .catch((error: Error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.message ?? 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  /*
   *
   * SALVAR MOVIMENTACAO
   *
   *
   */

  const isBlockSaveButton = (): boolean => {
    const enableButton = false
    const disableButton = true

    //Adicione esta verificação no início
    if (consolidacaoFechada) {
      return disableButton
    }

    const hasFieldErrors = !Object.values(errorsTotalVision).every(
      (values) => !values
    )
    if (hasFieldErrors) {
      return disableButton
    }

    if (dataAtuacaoInvalida) {
      return disableButton
    }

    if (dataAtuacaoInvalida) {
      return disableButton
    }

    if (!movState.isCompetenciaAtual || blockTotalVision) {
      return disableButton
    }

    if (movState?.isCompetenciaAtual) {
      return enableButton
    }

    if (movState?.isCompetenciaAtual && movState.flStatusMobilizacao === '0') {
      return enableButton
    }

    if (
      movState.compAtual.length !== 0 &&
      movState.compAtual.filter(
        (effetive) => effetive.cdStatus.trim().toLowerCase() === 'ativo'
      ).length == 0
    ) {
      return enableButton
    }

    return enableButton
  }

  const handleValidateEndSendToValidate = async () => {



    if (!movState.flStatusMobilizacao) {
      showModal({
        hideButtonCancel: true,
        message: 'Informe uma mobilização',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
      return
    }



    const semMovimentacao = !movState.movimentacaoId as boolean

    if (
      (isSomenteCompartilhado || isSemMobilizacao || isComMobilizacao) &&
      semMovimentacao
    ) {
      if (allDatadescripted.Perfil !== 'Csn') {
        showModal({
          handleConfirm: () => {
            if (!movState.movimentacaoId) handleCreateMovimentacao()
          },
          message: `Confirma os valores inseridos para os campos Total Salario Base, Total Folha de Pagamento e Valor Hora Extra?`,
          txtButtonCancel: 'NÃO',
          txtButtonConfirm: 'SIM',
          type: 'alert'
        })
      } else {
        if (!movState.movimentacaoId) handleCreateMovimentacao()
      }
      // handleCreateMovimentacao()
      return
    }
    if (allDatadescripted.Perfil !== 'Csn') {
      showModal({
        handleConfirm: async () => {
          // if ([isAnalista, isContraparte].includes(true)) {
          //   await handleEnviarEvidencias();
          // }



          handleEnviarValidar({ action: 'updateMov' })
        },
        message: `Confirma os valores inseridos para os campos Total Salario Base, Total Folha de Pagamento e Valor Hora Extra?`,
        txtButtonCancel: 'NÃO',
        txtButtonConfirm: 'SIM',
        type: 'alert'
      })
    } else {
      // if ([isAnalista, isContraparte].includes(true)) {
      //   await handleEnviarEvidencias();
      // }
      handleEnviarValidar({ action: 'updateMov' })
    }
  }

  return (
    <SimpleCollapse title="MOVIMENTAÇÃO MENSAL ( VISÃO TOTAL )">
      <DadosEfetivo />
      <Tipo />
      <EfetivoNumero
        isDataExpirada={isDataExpirada}
        consolidacaoFechada={consolidacaoFechada} // Adicione esta prop
      />
      <HorasExtras />
      <ValoresContratada />
      {/* ANEXAR EVIDENCIAS */}
      {allDatadescripted.Perfil === 'Csn' && (
        <AnexarEvidencias
          listFiles={listaEvidencias}
          onPutFile={onPutFile}
          bloquearAcoes={
            (allDatadescripted.Perfil === 'Csn' ? false : true)
          }
          deleteEvidencia={handleDeleteEvidencias}
        />
      )}

      <Row
        justifyContent="flex-end"
        marginBottom={SPACING.spacing20}
        marginRight={SPACING.spacing20}
      >
        <Button
          text="Limpar"
          variantButton="text"
          marginRight={SPACING.spacing20}
          onClick={() => {
            setMovState((old) => ({
              ...old,
              visaoTotal: {
                ...movState.visaoTotal,
                peHeVariacao: '',
                qtHeNormal: '',
                qtHeQtd: '',
                txHeJustificativa: '',
                txNeJustificativa: '',
                vlFolhaPagto: '',
                vlHoraExtras: '',
                vlSalBase: ''
              }
            }))
          }}
          disabled={
            blockTotalVision ||

            isSomenteCompartilhado ||
            isSemMobilizacao
          }
        />
        <Button
          text="Voltar"
          variantButton="outlined"
          marginRight={SPACING.spacing20}
          onClick={() => handleTab(null, 0)}
        />
        <Button
          text={
            allDatadescripted.Perfil === 'Csn'
              ? 'Validar'
              : 'Enviar para Validação'
          }
          onClick={handleValidateEndSendToValidate}
          disabled={isBlockSaveButton()}
        />
      </Row>
    </SimpleCollapse>
  )
}

export default VisaoTotal